import { handleActions } from 'redux-actions';
import { jobStatuses } from '../constants/jobs';
import { GET_ALL_JOBS_SUCCESS, GET_JOB_DETAILS_SUCCESS, POST_JOB_SUCCESS, GET_COST_PAY_RATE_SUCCESS, CLEAR_JOB_DETAILS,
  GET_COST_PAY_RATE_START, GET_COST_PAY_RATE_ERROR, UPDATE_JOB_CONVERSATION_ID } from '../actions/actionTypes';

const initialState = {
  jobsList: [],
  pagesQuantity: 0,
  jobDetails: {
    employer: {},
    event: {},
    job_workers: []
  },
  costPayRateList: [],
  costPayRateIsLoading: false,
  pastJobsWarning: false
};

export default handleActions(
  {
    [GET_ALL_JOBS_SUCCESS]: (state, action) => ({
      ...state,
      jobsList: action.jobsList,
      pagesQuantity: action.pagesQuantity,
      pastJobsWarning: action.pastJobsWarning
    }),
    [GET_JOB_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      jobDetails: action.payload
    }),
    [POST_JOB_SUCCESS]: (state, action) => ({
      ...state,
      jobDetails: {
        ...state.jobDetails,
        status: jobStatuses.posted.server,
        is_post_to_board: action.post_to_board
      }
    }),
    [GET_COST_PAY_RATE_START]: state => ({
      ...state,
      costPayRateIsLoading: true,
      costPayRateList: []
    }),
    [GET_COST_PAY_RATE_SUCCESS]: (state, action) => ({
      ...state,
      costPayRateList: action.costPayRateList,
      costPayRateIsLoading: false
    }),
    [GET_COST_PAY_RATE_ERROR]: state => ({
      ...state,
      costPayRateIsLoading: false,
      costPayRateList: []
    }),
    [CLEAR_JOB_DETAILS]: state => ({
      ...state,
      jobDetails: {
        employer: {},
        event: {},
        job_workers: []
      }
    }),
    [UPDATE_JOB_CONVERSATION_ID]: (state, action) => ({
      ...state,
      jobDetails: {
        ...state.jobDetails,
        conversation_id: action.conversation_id
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/jobs.js